import { Button } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { ErrorFaceIcon } from '../../../atoms/error-face-icon';
import errorDetails from '../errorDetails';
import { IProps } from '../ErrorPage';

import { SummaryHeader, SummaryText, ButtonContainer, SummaryContainer } from './ErrorSummary.styles';

const CTAButton = ({ errorCode }: IProps) => {
  return (
    <ButtonContainer>
      <Button onClick={errorDetails.get(errorCode)?.CTADetails.onClick} variant={'solid'}>
        {errorDetails.get(errorCode)?.CTADetails.text}
      </Button>
    </ButtonContainer>
  );
};

const ErrorSummary = ({ errorCode }: IProps) => (
  <SummaryContainer>
    <ErrorFaceIconStyled />
    <SummaryHeader>{errorDetails.get(errorCode)?.header}</SummaryHeader>
    <SummaryText>{errorDetails.get(errorCode)?.text}</SummaryText>
    <CTAButton errorCode={errorCode} />
  </SummaryContainer>
);

const ErrorFaceIconStyled = styled(ErrorFaceIcon)`
  margin: 0 auto;
`;

export default ErrorSummary;
